import React, { useEffect, useState } from "react";
import CustomButton from "../../components/form/CustomButton";
import FiltersPagination from "../../components/elements/FiltersPagination";
import DataTableElement from "../../components/elements/DataTableElement";
import { Columns } from "./Columns";
import { clientsCompanyResource, suppliersResource } from "../../helpers/configRoutes/backend_helper";
import AddUpSupplier from "./AddUpSupplier";
import { useDispatch } from "react-redux";
import { reset_supplier, update_supplier } from "../../store/suppliers/action";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";

const Suppliers = () => {
    const [filters, setFilters] = useState({ endDate: '', startDate: '', search: '', from: 0, to: 0, page: 1 });
    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const dispatch = useDispatch()
    const [items, setItems] = useState([]);
    const [tableLoad, setTableLoad] = useState({ show: false });
    const [suppliers, setSuppliers] = useState([]);
    const [company, setCompany] = useState([]);
    const [modal, setModal] = useState({ show: false });
    const [modalConfirm, setModalConfirm] = useState({ show: false, title: 'Delete supplier', loadig: false, textLoad: 'Processing' })

    const deleteSupplier = async () => {
        setModalConfirm({ ...modalConfirm, loading: true })
        const response = await suppliersResource('del', {}, modalConfirm.id);
        if (response.status) {
            setFilters({ ...filters,show:filters.show })
        }
        setModalConfirm({ ...modalConfirm, loading: false, show: false, id: null })
    }


    const openModalAdd = (supplierItem = {}) => {
        //VAmos a seteart la funcion de readux para el valor de validation
        dispatch(supplierItem.id ? update_supplier(supplierItem) : reset_supplier())
        //
        setModal({
            ...modal,
            show: true,
            title: supplierItem.id ? "Edit Supplier" : "Add Supplier",
        });
    };

    useEffect(() => {
        const SupplierRequest = async () => {
            try {
                const response = await suppliersResource("get", {});
                setSuppliers(response.suppliers)
            } catch (error) {
                console.error("Error fetching service order:", error);
            }
        };

        SupplierRequest();
    }, [filters]);
    const cols = Columns(openModalAdd,setModalConfirm);
    return (
        <div className="p-8">
            <div className="flex justify-between items-center mb-4">
                <div className="text-2xl font-semibold">Suppliers</div>
                <div className="font-semibold">
                    <CustomButton
                        onClick={() => openModalAdd()} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
                        + Create New Supplier
                    </CustomButton>
                </div>
            </div>
            <FiltersPagination showFilters={true} filters={filters} setFilters={setFilters} meta={meta} statusModel={'Settlement'}>
                <DataTableElement columns={cols} items={suppliers} tableLoad={tableLoad} />
            </FiltersPagination>
            {modal.show &&
                <>
                    <AddUpSupplier modal={modal} setModal={setModal} filters={filters} setFilters={setFilters} />
                    

                </>
            }
            {modalConfirm.show &&
            <ConfirmDeleteModal modal={modalConfirm} setModal={setModalConfirm} action={deleteSupplier} />
            }
        </div>
    )

}

export default Suppliers;